import CustomTable from 'components/custom-table/CustomTable';
import DownloadContext from 'contexts/DownloadContext';
import ApiServerRequest from 'models/ApiServerRequest';
import EmailTemplate from '../../models/EmailTemplate';
import * as React from 'react';
import { sendFetchError } from 'utils/messageUtils';
import ActionCell from 'components/custom-table/action/ActionCell';
import { Modal, ModalBody, ModalTitle } from '@symphony-ui/uitoolkit-components';
const EmailSettingsModal = ({ close, deleteFn, openFn }) => {
    const { apiFetchJson } = React.useContext(DownloadContext);
    const [hasError, setError] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false);
    const [templates, setTemplates] = React.useState([]);
    React.useEffect(() => {
        const request = new ApiServerRequest('/syndicate/email-template/all');
        setLoading(true);
        (async () => {
            try {
                const body = await apiFetchJson(request);
                const downloaded = body.map(e => new EmailTemplate(e));
                setTemplates(downloaded);
            }
            catch (error) {
                if (!(error instanceof Error && error.name === 'AbortError')) {
                    sendFetchError('Unable to download Email Template', error, request);
                    setError(true);
                }
            }
            finally {
                setLoading(false);
            }
        })();
    }, [apiFetchJson]);
    const actionElements = React.useMemo(() => [], []);
    const columns = React.useMemo(() => [
        {
            cell: ActionCell,
            id: 'actions',
            meta: {
                actionsMenu: [
                    { callback: openFn, label: 'Open' },
                    { callback: deleteFn, label: 'Delete' },
                ],
            },
            size: 28
        },
        { accessorKey: 'name', header: 'Name', id: 'name' },
        { accessorKey: 'subject', header: 'Subject', id: 'subject' }
    ], [deleteFn, openFn]);
    return (React.createElement(Modal, { className: 'cmo-dropdown-absolute', closeButton: true, onClose: close, show: true, size: "large" },
        React.createElement(ModalTitle, null, "Email Templates"),
        React.createElement(ModalBody, null,
            React.createElement(CustomTable, { actionElements: actionElements, columns: columns, data: templates, emptyMessage: 'No Email Templates yet', errorMessage: 'Error downloading Email Templates', hasError: hasError, isLoading: isLoading, name: "email-template" }))));
};
export default EmailSettingsModal;
